import styled from 'styled-components'

import { StyledTimeProps } from './EventStatisticTime.types'

export const StyledTime = styled.div<StyledTimeProps>`
  color: ${(p) => p.theme.colors.custom.blue[p.isPlain ? 13 : 14]};
  line-height: 16px;
  white-space: nowrap;
`
